module.exports = {"542523100":"狮泉河镇","542523200":"昆莎乡","542523201":"左左乡","542523202":"门士乡","542523203":"扎西岗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542523.json
// module id = 2907
// module chunks = 0